import { getGtmData } from '..';
import { encryptString } from '../../utils/encrypt';

const registration = () => ({
  // 1. FATCA Declaration Page
  fatcaDeclarationPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/registration/home',
    //   title: 'PFM - Online Investments - Registration - Home',
    //   cd24: getGtmData('cd24'), // <<pass platform either website or internet-banking or mobile-app>>
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Registration - Landing Page',
    // });
  },

  // buttonType can be either Cancel or Confirm
  fatcaDeclarationButtonClick: (buttonType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Registration - Landing Page - ${buttonType}`,
    // });
  },

  // 2. FATCA Declaration Modal
  fatcaDeclarationModalOnLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/registration/home/user-allowed-to-invest',
    //   title: 'PFM - Online Investments - Registration - Home - User Allowed to Invest',
    // }),
    //   recordEventWrapper({
    //     event: 'event_PFM_on_page_load_event',
    //     category: 'PFM',
    //     action: 'Online Investments',
    //     label: 'Registration - Landing Page - User Allowed to Invest',
    //   });
  },

  // modalButton can be either Yes or No
  fatcaDeclarationModalButtonClick: (modalButton: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Registration - Landing Page - Cancel - User Allowed to Invest - ${modalButton}`,
    // });
  },

  // 3. FATCA Declined
  fatcaDeclinedPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/registration/home/user-allowed-to-invest/not-allowed',
    //   title: 'PFM - Online Investments - Registration - Home - User Allowed to Invest - Not Allowed',
    // }),
    //   recordEventWrapper({
    //     event: 'event_PFM_on_page_load_event',
    //     category: 'PFM',
    //     action: 'Online Investments',
    //     label: 'Registration - Landing Page - User Allowed to Invest - Not Allowed',
    //   });
  },

  fatcaDeclineOkClick: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Registration - Landing Page - Cancel - User Allowed to Invest - Not Allowed  - OK',
    // });
  },

  // 4. FATCA Declaration form
  fatcaDeclarationFormPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/registration/fatca-declaration',
    //   title: 'PFM - Online Investments - Registration - FATCA Declaration',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Registration - FATCA Declaration',
    // });
  },

  // buttonType can be either Continue or Back
  fatcaDeclarationFormButtonClick: (buttonType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Registration - FATCA Declaration - ${buttonType}`,
    // });
  },

  // 5. Risk Profiler Page
  riskProfilePageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/registration/risk-profiler',
    //   title: 'PFM - Online Investments - Registration - Risk Profiler',
    // }),
    //   recordEventWrapper({
    //     event: 'event_PFM_on_page_load_event',
    //     category: 'PFM',
    //     action: 'Online Investments',
    //     label: 'Registration - Risk Profiler',
    //   });
  },

  riskProfileIamConfusedClick: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Registration - Risk Profiler - I am Confused',
    // }),
    //   recordEventWrapper({
    //     event: 'event_PFM_on_click_vpv',
    //     page: 'vpv/pfm/online-investments/registration/risk-profiler/i-am-confused',
    //     title: 'PFM - Online Investments - Registration - Risk Profiler - I am Confused',
    //   });
  },

  riskProfileOnNextClick: (riskProfile: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Registration - Risk Profiler - Next',
    //   cd72: riskProfile,
    // });
  },

  // 6. Risk Profile Questionnaire
  riskAssessmentPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/registration/risk-profiler/i-am-confused/risk-assessment',
    //   title: 'PFM - Online Investments - Registration - Risk Profiler - I am Confused - Risk Assessment',
    // }),
    //   recordEventWrapper({
    //     event: 'event_PFM_on_page_load_event',
    //     category: 'PFM',
    //     action: 'Online Investments',
    //     label: 'Registration - Risk Profiler - I am Confused - Risk Assessment',
    //   });
  },

  riskAssessmentNextClick: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Registration - Risk Profiler - I am Confussed - Risk Assessment - Next',
    // });
  },

  // 7. Bank Linking Page
  bankLinkingPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/registration/link-your-bank-account',
    //   title: 'PFM - Online Investments - Registration - Link Your Bank Account',
    // }),
    //   recordEventWrapper({
    //     event: 'event_PFM_on_page_load_event',
    //     category: 'PFM',
    //     action: 'Online Investments',
    //     label: 'Registration - Link Your Bank Account',
    //   });
  },

  bankLinkingTermsAndConditionClick: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Registration - Link Your Bank Account - Terms and Conditions',
    // });
  },

  // Below GTM not feasible
  bankLinkingConfirmClick: (investmentId: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Registration - Registration Successful',
    //   cd74: encryptString(investmentId), // Pass the investment ID in <<investment_id>>
    // }),
    //   recordEventWrapper({
    //     event: 'event_PFM_on_page_load_vpv',
    //     page: 'vpv/pfm/online-investments/registration/registration-successful',
    //     title: 'PFM - Online Investments - Registration - Registration Successful',
    //   });
  },
});
export default registration;
